"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const octopod_auth_1 = require("@produits-internes-oss/octopod-auth");
const react_1 = require("react");
const useStore_1 = require("../../contexts/useStore/useStore");
const PanelPerson_1 = require("../../presenters/PanelPerson/PanelPerson");
const Search_1 = require("../../presenters/Search/Search");
const PersonView_styled_1 = require("./PersonView.styled");
const PersonView = ({ slug }) => {
    const { connection } = (0, octopod_auth_1.useAuthenticator)();
    const { open } = (0, useStore_1.useStore)();
    const me = (0, react_1.useMemo)(() => slug === 'me' && connection.id, [slug, connection]);
    const id = (0, react_1.useMemo)(() => me || parseInt(slug) || open('people').where((person) => person.match(slug))[0]?.id, [slug, open, me]);
    const person = (0, react_1.useMemo)(() => open('people').find(id), [id, open]);
    return ((0, jsx_runtime_1.jsxs)(PersonView_styled_1.PersonViewStyled, { children: [(0, jsx_runtime_1.jsx)(Search_1.Search, { className: "search" }), person && (0, jsx_runtime_1.jsx)(PanelPerson_1.PanelPerson, { person: person })] }));
};
exports.PersonView = PersonView;
//# sourceMappingURL=PersonView.js.map